module.exports = __webpack_public_path__ + "img/level_four.6f20f55e.png";